// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../index';

import { gql } from 'graphql-tag';
import { CustomerRegistrationResponseFragmentDoc } from '../auth/fragments/customerRegistrationResponse.generated';
import { RbFragmentDoc } from '../ring-builder/rb.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const RingBuilderResolveNewCustomerDocument = gql`
    mutation ringBuilderResolveNewCustomer($input: RingBuilderResolveInput!, $customer: CustomerRegistrationInput!, $currency: CurrencyInput!, $region: RegionCode!, $locale: Locale!, $isConsultant: Boolean!) {
  ringBuilderResolveNewCustomer(input: $input, customer: $customer) {
    __typename
    ... on RingBuilderResolvedNewCustomerSuccess {
      customer {
        ...customerRegistrationResponse
      }
      ringBuilder {
        ...rb
      }
      redirect
    }
    ... on RingBuilderResolvedFailure {
      errors
    }
  }
}
    ${CustomerRegistrationResponseFragmentDoc}
${RbFragmentDoc}`;

export function useRingBuilderResolveNewCustomerMutation() {
  return Urql.useMutation<SchemaTypes.RingBuilderResolveNewCustomerMutation, SchemaTypes.RingBuilderResolveNewCustomerMutationVariables>(RingBuilderResolveNewCustomerDocument);
};